import React from "react";

export default function TownhomesForSale() {
  return <div>TownhomesForSale</div>;
}
